import React, { useState, useEffect, Fragment } from "react";
import clsx from "clsx";

interface TitleProps {
    children: React.ReactNode;
    size?: string;
    weight?: string;
    color?: string;
    align?: string;
    className?: string;
}

const SectionTitle: React.FC<TitleProps> = ({
    children,
    size = "text-2xl",
    weight = "font-semibold",
    color = "text-titleColor",
    align = "text-center",
    className = "",
}) => {
    return (
        <h1 className={clsx(size, weight, color, align, className)}>
            {children}
        </h1>
    );
};

export default SectionTitle;